import SecureLS from "secure-ls";

const secureLs = new SecureLS({ encodingType: "aes" });
const isDebuggingEnvironment = process.env.NODE_ENV === "development";

const baseLocalStorage = {
  get: key => {
    return isDebuggingEnvironment
      ? localStorage.getItem(key)
      : secureLs.get(key);
  },
  set: (key, data) => {
    return isDebuggingEnvironment
      ? localStorage.setItem(key, data)
      : secureLs.set(key, data);
  },
  remove: key => {
    return isDebuggingEnvironment
      ? localStorage.removeItem(key)
      : secureLs.remove(key);
  },
  clear: () => {
    return isDebuggingEnvironment ? localStorage.clear() : secureLs.clear();
  }
};

export const xLocalStorage = {
  ...baseLocalStorage,
  getParsed: key => {
    return JSON.parse(
      baseLocalStorage.get(key) ? baseLocalStorage.get(key) : "{}"
    );
  }
};
